import { render, staticRenderFns } from "./stockItemsFilterBox.vue?vue&type=template&id=f0579122&"
import script from "./stockItemsFilterBox.vue?vue&type=script&lang=ts&"
export * from "./stockItemsFilterBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports